import { CustomTable, Modal, InputDate, Combobox, EInputTypes, InputTextCustom, GetItemsProps } from "medere-ui-framework"
import { useEffect, useId, useRef, useState, BaseSyntheticEvent } from "react"
import { Column } from "primereact/column"
import Checkbox from '@mui/material/Checkbox';
import { Button } from "primereact/button"
import { getAccountingMovementTypes, getAccountingMovements, removeAccountingMovement, findAAById,  getAllAccountingAccountsByLevel, saveAccountingMovementDetail, saveAccountingMovement, getAccountingMovementById, getAccountingMovementDetailsByAccountingMovementId, generateAccountingClosureEntry, generateAccountingOpeningEntry, getLastAccountingDateOfOpeningEntry, getAllAccountings } from "../servicesHooks/Accounting/useAccountingService"
import { showMessage } from '../utils/messages'
import { Toast } from 'primereact/toast'
import { AccountingMovementType, AccountingAccount, AccountingMovementDetail, EAccountingMovementType, defaultAllAccountingMovementType, Accounting } from "../interface/interface";
import { format, formatISO } from 'date-fns'
import { es } from 'date-fns/locale'
import { useSearchParams } from 'react-router';
import { normalize } from '../hooks/useOrderOfProvision'

function AccountingMovementsView() {
//---------------------consts Vista inicio-------------------------------------------------------------------------------------
    const tableRef = useRef<any>(null)
    const toast = useRef<any>(null)
    const [searchParams] = useSearchParams();
    const [selectedAccountingMovement, setSelectedAccountingMovement] = useState<any>()
    const [accountingMovementType, setAccountingMovementType] = useState<AccountingMovementType>(defaultAllAccountingMovementType)
    const [accountingDate, setAccountingDate] = useState(null)
    const [manual, setManual] = useState(true)
    const [lastAccountingDateOfAccountingEntry, setLastAccountingDateOfAccountingEntry] = useState<any>()
    const [editMode, setEditMode] = useState(false)
    const [elimMode, setElimMode] = useState(false)
    const today = new Date()
    const [visible, setVisible] = useState(false)
//---------------------consts Vista fin----------------------------------------------------------------------------------------



//---------------------consts Modal inicio-------------------------------------------------------------------------------------
    const [accountingMovementDetailList, setAccountingMovementDetailList] = useState<AccountingMovementDetail[]>([])
    const [selectedAccountingMovementDetail, setSelectedAccountingMovementDetail] = useState<any>()
    const [eliminationList, setEliminationList] = useState<number[]>([])
    const [accountingMovementTypeModal, setAccountingMovementTypeModal] = useState<AccountingMovementType>()
    const [description, setDescription] = useState("")
    const [closeDate, setCloseDate] = useState<Date|null>(null)
    const [closureFromDateModal, setClosureFromDateModal] = useState<Date|null>(null)
    const [isClosureEntryModal, setIsClosureEntryModal] = useState(false)
    const [disableButtonClosureEntryModal, setDisableButtonClosureEntryModal] = useState(false)
    const [isOpeningEntryModal, setIsOpeningEntryModal] = useState(false)
    const [generatingOpeningEntryModal, setGeneratingOpeningEntryModal] = useState(false)
    const [accountingMovementId, setAccountingMovementId] = useState<number>()
    const [index, setIndex] = useState<number>(0)

    const [addModeModal, setAddModeModal] = useState(false)
    const [editModeModal, setEditModeModal] = useState(false)
    const [elimModeModal, setElimModeModal] = useState(false)
    const [infoModal, setInfoModal] = useState(false)
    const [addingTotalizers, setAddingTotalizers] = useState(false);
    const [sumDebitValues, setSumDebitValues] = useState<number>(-1)
    const [sumCreditValues, setSumCreditValues] = useState<number>(-1)
    const indexTotalizerDC = 999999
    const tableRefModal = useRef<any>(null)
    const toastModal = useRef<any>(null)
    const toastSave = useRef<any>(null)
    const [debit, setDebit] = useState<any>(null)
    const [credit, setCredit] = useState<any>(null)
    const [accountingAccount, setAccountingAccount] = useState<AccountingAccount>()
    const [debitError, setDebitError] = useState(false)
    const [creditError, setCreditError] = useState(false)
    const [accountingAccountError, setAccountingAccountError] = useState(false)

    const [readOnly, setReadOnly] = useState<number|null>(null)
    const [defaultAccountingMovement, setDefaultAccountingMovement] = useState<number|null>(null)
    const [accounting, setAccounting] = useState<Accounting>()
//---------------------consts Modal fin----------------------------------------------------------------------------------------













//---------------------logica Vista inicio-------------------------------------------------------------------------------------
    const handleCheckboxChange = () => {
        setManual(!manual);
    };

    //habilita la Modal para que sea editable y este vacia
    function handleAddMode() {
        setReadOnly(1);
        setDefaultAccountingMovement(0)
        setVisible(true)
    }

    //si la fecha de la cabecera del asiento es valida y el asiento fue generado de manera manual, la cabecera es editable, de lo contrario es de solo lectura
    async function handleEditMode() {
        setDefaultAccountingMovement(selectedAccountingMovement.accountingmovement)
        if (selectedAccountingMovement.manual){
            setReadOnly(1)  //editable
        }else{
            setReadOnly(0)  //no editable
        }
        setEditMode(true)
        setVisible(true)
    }

    //si la fecha de la cabecera del asiento es valida, lo borra
    async function handleElimMode() {
            removeAccountingMovement(selectedAccountingMovement.accountingmovement)
            .then(() => {
                showMessage(toast, 'Asiento eliminado', 'success')
                refresh()
            }).catch((err) => {
                console.error(err)
                showMessage(toast, 'Error al eliminar el asiento', 'error')
            })
            setElimMode(false)
            setSelectedAccountingMovement(undefined)
    }

    //autorecarga la tabla de la Vista
    function refresh(){
        if (tableRef) {
            tableRef.current.refreshTable()
        }
    }

    //si no se selecciona una fecha de filtrado, por defecto filtra a partir del ultimo asiento de inicio del ejercicio, formateandolo
    useEffect(() => {
        getLastAccountingDateOfOpeningEntry()
        .then(res => {
            let date
            if (res.accountingdate && res.accountingdate != "")
                date = new Date(res.accountingdate)
            else{
                date = new Date()
                date.setMonth(date.getMonth() - 1);
            }
            date.setUTCHours(0)
            date.setUTCMinutes(0)
            const formattedClosingDate = formatISO(new Date(date? date:new Date()));
            const opEntryAccountingDate = { ...res, accountingdate: formattedClosingDate };
            setLastAccountingDateOfAccountingEntry(opEntryAccountingDate);
        })
        .catch(err => {
            console.error(err)
            setLastAccountingDateOfAccountingEntry(undefined)
        })
    }, [])

    //al filtrar en la Vista, se autorefresca la tabla de la vista
    useEffect(() => {
        refresh()
    }, [accountingDate, accountingMovementType, manual])

    //si tenias seleccionado en la vista una cabecera que no fue generado de manera manual, y pasa a activar la opcion para ver solo los manuales, te desselecciona la cabecera, pues ya no la ves mas en la tabla
    useEffect(() => {
        if (selectedAccountingMovement && !selectedAccountingMovement.manual){
            setSelectedAccountingMovement(undefined)
        }
    }, [manual])
//---------------------logica Vista fin----------------------------------------------------------------------------------------








//---------------------logica Modal inicio-------------------------------------------------------------------------------------

        //un cleanVariables si se cierra la ventana de agregar detalle en la Modal de detalles, o si se abre, dar la id de la cabecera a la que pertenece si se esta editando
        useEffect(() => {
            if (visible==false){
                setAccountingMovementDetailList([]);
                setEliminationList([])
                setReadOnly(null);
                setDefaultAccountingMovement(null)
                setDescription("")
                setAccountingMovementTypeModal(undefined)
                setCloseDate(null)
                setAccountingMovementId(undefined)
                setDisableButtonClosureEntryModal(false)
                setClosureFromDateModal(null)
                if (editMode)
                    setEditMode(false)
            } else{
                setCloseDate(generateFromDate())
                setAccountingMovementId(editMode? selectedAccountingMovement.accountingmovement:-1)
            }
        }, [visible])

        //Para el caso de haber seleccionado "asiento de apertura", se aparece una ventana para aceptar generarlo, y en caso de cerrar la ventana sin haber puesto "Si", se tiene que deseleccionar ese asiento de apertura. Eso es lo que se hace aca
        useEffect(() => {
            if (!isOpeningEntryModal && !generatingOpeningEntryModal)
                setAccountingMovementTypeModal(undefined)
        }, [isOpeningEntryModal])

        //precarga los detalles de la Modal, si editas una cabecera en la Vista
        useEffect(() => {
            if (defaultAccountingMovement && accountingMovementDetailList.length == 0){
                getAccountingMovementById(defaultAccountingMovement)
                .then((res:any) => {
                    if (selectedAccountingMovement.closurefromdate != null){
                        const fechaFormateada = format(new Date(selectedAccountingMovement.closurefromdate), "EEE MMM dd yyyy HH:mm:ss 'GMT'xxx (zzz)");
                        setClosureFromDateModal(new Date(fechaFormateada))
                    }
                    const fechaFormateada = format(new Date(res.accountingdate), "EEE MMM dd yyyy HH:mm:ss 'GMT'xxx (zzz)");
                    setCloseDate(new Date(fechaFormateada))
                    setAccountingMovementTypeModal({accountingmovementtype: res.accountingmovementtype, descriptionaccountingmovement: res.descriptionaccountingmovementtype})
                    setDescription(res.descriptionaccountingmovement)
                })
                getAccountingMovementDetailsByAccountingMovementId(defaultAccountingMovement).then((res:any) => {
                    res.forEach((element:AccountingMovementDetail) => {
                        const { debitcredit, valueamd, balance, accountingaccount, descriptionaccountingaccount, accountingmovementdetail } = element;
                        addAccountingMovementDetailToList(debitcredit, valueamd, balance, accountingaccount, descriptionaccountingaccount, accountingmovementdetail, true);
                    });
                })
            }
        }, [editMode])

        //si en la Modal, editas un detalle, te precarga los datos al abrir la ventana de detalles, de lo contrario aparece vacia
        useEffect(() => {

            if (selectedAccountingMovementDetail && editModeModal) {
                if (selectedAccountingMovementDetail.debitcredit == 'D'){
                    setDebit(selectedAccountingMovementDetail.valueamd)
                }
                else{
                    setCredit(selectedAccountingMovementDetail.valueamd)
                }

                findAAById({ accountingAccountId: selectedAccountingMovementDetail.accountingaccount })
                .then(res =>
                    setAccountingAccount(res)
                )
            }

        }, [addModeModal])

        //por cada que se modifica la lista, se borra y se inserta el totalizador para recalcular y que quede al final al volver a insertarse, se le da tiempo porque sino el refresh no muestra el totalizador
        useEffect(() => {
            setTimeout(() => {
                if (accountingMovementDetailList.length != 0 && !addingTotalizers)
                    addTotalizersDebitCreditToList(accountingMovementDetailList)
                else
                    setAddingTotalizers(false)

                refreshModal()

            }, 25);
        }, [accountingMovementDetailList])

        //si no le doy tiempo, el refresh no muestra los totalizadores
        useEffect(()=>{
            setTimeout(()=>{
                refreshModal()
            },100)
        },[sumDebitValues, sumCreditValues])

        useEffect(()=>{
            if (!editModeModal)
                switch (accountingMovementTypeModal && accountingMovementTypeModal.accountingmovementtype) {
                    case EAccountingMovementType.CLOSUREENTRY:
                        setIsClosureEntryModal(true);
                        setIsOpeningEntryModal(false);
                        break;
                    case EAccountingMovementType.OPENINGENTRY:
                        setIsOpeningEntryModal(true);
                        setIsClosureEntryModal(false);
                        break;
                    default:
                        setIsClosureEntryModal(false);
                        setIsOpeningEntryModal(false);
                        break;
                }
        },[accountingMovementTypeModal])

        useEffect(()=>{
            setAccountingAccount(undefined)
        },[accounting])

        //antes de guardar los datos, verifica si el Debe y el Haber son iguales
        function handleClickModal() {
            if (sumDebitValues == sumCreditValues){
                setInfoModal(false)
                handleSaveAccountingMovementModal()
            }else
                showMessage(toastSave, 'La suma del Debe y el Haber no son iguales', 'error')
        }

        //abre la ventana de detalles, setea en falso editModeModal, porque pudo haber quedado true si editaba uno primero
        function handleAddModeModal() {
            cleanVariablesModalDetailFromModal()
            setEditModeModal(false)
            setAddModeModal(true)
        }

        //si editas, te abre la ventana con addModeModal, y activa editModeModal para que en el useEffect de addMode se precarguen los datos
        function handleEditModeModal() {
            cleanVariablesModalDetailFromModal()
            setEditModeModal(true)
            setAddModeModal(true)
        }

        //una vez verificado todo, guarda lo cargado en memoria
        function handleSaveAccountingMovementModal() {
            saveAccountingMovement({
                accountingmovement: accountingMovementId? accountingMovementId:-1,
                accountingdate: closeDate,
                accountingmovementtype: accountingMovementTypeModal?.accountingmovementtype,
                descriptionaccountingmovement: description,
                manual: true,
                closurefromdate: closureFromDateModal,
            })
            .then((response) => {

                setAccountingMovementId(response)

                setTimeout(()=>{
                    saveAccountingMovementDetail({
                        accountingmovementdetaillist: accountingMovementDetailList,
                        accountingmovement: response,
                        eliminationlist: eliminationList
                    })
                    .then(() => {
                        showMessage(toast, 'Asiento guardado', 'success')

                        setAccountingMovementDetailList([]);
                        setEliminationList([])
                        setReadOnly(null);
                        setDefaultAccountingMovement(null)
                        setDescription("")
                        setAccountingMovementTypeModal(undefined)
                        setCloseDate(null)
                        setSelectedAccountingMovement(undefined)

                        setTimeout(()=>{
                            refresh()
                            setTimeout(()=>{
                                setEditMode(false)
                                setVisible(false)
                            }, 100)

                        }, 100)
                    }).catch((error) => {
                        console.error(error);
                    })
                }, 100)

            })



        }

        //trae los detalles de un accountingmovement de cierre, para guardarlo, a partir de invertir los saldos del deb y haber de la query de balance t sumas y saldos
        function handleClosureEntryModal() {

            setDisableButtonClosureEntryModal(true)

            generateAccountingClosureEntry(closureFromDateModal, closeDate).then((res:any) => {
                res.forEach((element:AccountingMovementDetail) => {
                    const { debitcredit, valueamd, balance, accountingaccount, descriptionaccountingaccount, accountingmovementdetail } = element;
                    addAccountingMovementDetailToList(debitcredit, valueamd, balance, accountingaccount, descriptionaccountingaccount, accountingmovementdetail, true);
                });
            })
        }

        //trae los detalles de un accountingmovement de apertura, a partir del ultimo asiento de cierre, para el cual invierte su debe y haber
        function handleOpeningEntryModal() {
            setGeneratingOpeningEntryModal(true)
            setIsOpeningEntryModal(false)

            //query que trae el ultimo de cierre, hacer de cero. Si no hay, que no se rompa, que solo muestre un showMessage (hacer lo mismo con el de cierre)
            generateAccountingOpeningEntry().then((res:any) => {
                res.forEach((element:AccountingMovementDetail) => {
                    const { debitcredit, valueamd, balance, accountingaccount, descriptionaccountingaccount, accountingmovementdetail } = element;
                    addAccountingMovementDetailToList(debitcredit, valueamd, balance, accountingaccount, descriptionaccountingaccount, accountingmovementdetail, true);
                });
                setGeneratingOpeningEntryModal(false)
            })

        }

        //getItems de la tabla en la Modal, que es la lista que contiene los detalles en memoria
        function crearPromesaConLista() {
            return Promise.resolve(accountingMovementDetailList)
        }

        function generateFromDate() {
            const currentDate = new Date();
            currentDate.setDate(currentDate.getDate());

            const year = currentDate.getFullYear();
            const month = currentDate.getMonth() + 1;
            const day = currentDate.getDate();

            const formattedMonth = month < 10 ? `0${month}` : month;
            const formattedDay = day < 10 ? `0${day}` : day;

            const formattedDate = `${year}-${formattedMonth}-${formattedDay}T03:00:00.000Z`;

            return new Date(formattedDate);
        }

        function deleteAccountingMovementDetail() {
            if (selectedAccountingMovementDetail){
                removeAccountingMovementDetailFromList(selectedAccountingMovementDetail.accountingmovementdetail, selectedAccountingMovementDetail.indexList)
                setElimModeModal(false)
                refreshModal()
            }else
                console.log("selectedAccountingEntry undefined")
        }

        //inserta un elemento de la lista de detalles
        async function addAccountingMovementDetailToList(debitcredit:string, valueamd:number, balance: number, accountingaccount: number, descriptionaccountingaccount: string, accountingmovementdetail: number, preloaded: boolean) {

            if (!preloaded && !validations()) {
                return
            }

            const newAccountingMovementDetail: AccountingMovementDetail = {
                accountingmovementdetail: preloaded? accountingmovementdetail:-1,
                debitcredit: debitcredit,
                valueamd: valueamd,
                balance: balance,
                accountingaccount: accountingaccount,
                accountingmovement: -1,
                descriptionaccountingaccount: descriptionaccountingaccount,
                indexList: index,
                valueamd2: -1,
            };

            setAccountingMovementDetailList((prevList) => [...prevList, newAccountingMovementDetail]);

            setIndex(index+1)
        };

        //borra un elemento de la lista de detalles
        async function removeAccountingMovementDetailFromList(accountingmovementid: number, indice: number) {
            setSelectedAccountingMovementDetail(undefined);
            if (accountingmovementid && accountingmovementid !== -1)
                setEliminationList((prevList) => [...prevList, accountingmovementid]);


            setAccountingMovementDetailList((prevList) => {
                const filteredList = prevList.filter((_elemento, index) => index !== indice);

                const reindexed = filteredList.map((element, index) => ({
                    ...element,
                    indexList: index,
                }));

                return reindexed;
            });

            setIndex(index-1)

        };

        //edita un elemento de la lista de detalles
        async function editAccountingMovementDetailOfList(accountingmovementdetailid:number, debitcredit:string, valueamd:number, balance: number, accountingaccount: number, descriptionaccountingaccount: string, indice: number){
            if (!validations()) {
                return
            }

            setSelectedAccountingMovementDetail(false)

            setAccountingMovementDetailList((prevList) => {
                const updatedList = [...prevList];
                const editedElement = {
                    accountingmovementdetail: accountingmovementdetailid,
                    debitcredit,
                    valueamd: normalize(valueamd, 2),
                    balance,
                    accountingaccount,
                    accountingmovement: -1,
                    descriptionaccountingaccount,
                    indexList: indice,
                    valueamd2: -1,
                };

                updatedList[indice] = editedElement;

                return updatedList;
            });

        }

        async function addTotalizersDebitCreditToList(list: AccountingMovementDetail[]){//añade la ultima fila de color de la tabla

            setAddingTotalizers(true)

            const sumD = list.reduce((total, element) => ( element.debitcredit === 'D' ? total + normalize(element.valueamd) : total ), 0);
            const sumC = list.reduce((total, element) => ( element.debitcredit === 'C' ? total + normalize(element.valueamd) : total ), 0);        

            setSumDebitValues(normalize(sumD, 2));
            setSumCreditValues(normalize(sumC, 2));

            const isBalanced = Math.abs(sumD - sumC) < 0.01;
            if (!isBalanced) {console.warn("Desbalance detectado: Debe y Haber no coinciden.");}

            setAccountingMovementDetailList((prevList) => {
                const filteredList = prevList.filter((elemento) => elemento.debitcredit !== 'DC');

                const reindexed = filteredList.map((element, index) => ({
                    ...element,
                    indexList: index,
                }));

                return reindexed;
            });

            setTimeout(() => {
                if (!(accountingMovementDetailList.length == 1 && accountingMovementDetailList[0].debitcredit == 'DC')){
                    setAddingTotalizers(true)

                    addAccountingMovementDetailTotalizersToList(
                        'DC',
                        sumD,
                        sumC
                    )
                }


            }, 50)
        }

        async function addAccountingMovementDetailTotalizersToList(debitcredit:string, valueamd:number, valueamd2: number) {

            const newAccountingMovementDetail: AccountingMovementDetail = {
                accountingmovementdetail: -1,
                debitcredit: debitcredit,
                valueamd: normalize(valueamd, 2),
                balance: 0,
                accountingaccount: -1,
                accountingmovement: -1,
                descriptionaccountingaccount: "",
                indexList: indexTotalizerDC,
                valueamd2: normalize(valueamd2, 2),
            };

            setAccountingMovementDetailList((prevList) => [...prevList, newAccountingMovementDetail]);

        };

        function cleanVariablesModalDetailFromModal() { //en la Modal de detalles, limpia los campos de la Modal de agregar/editar detalles
            setDebit(null)
            setCredit(null)
            setAccountingAccount(undefined)
            setAccounting(undefined)
            setDebitError(false)
            setCreditError(false)
            setAccountingAccountError(false)
        }

        function validations() {
            if (debit == null && credit == null) {
                setDebitError(true)
                setCreditError(true)
                return false
            }
            if (!accountingAccount){
                setAccountingAccountError(true)
                return false
            }

            return true
        }

        //refresca la tabla de la Modal
        function refreshModal(){
            if (tableRefModal) {
                tableRefModal.current.refreshTable()
            }
        }

        function addAccountingMovementDetail() {
            if (!validations()) {
                return
            }

            if (debit != null || credit != null) {

                if (!editModeModal){
                    addAccountingMovementDetailToList(//guarda en memoria
                        debit!=null? 'D': 'C',
                        debit!=null? debit: credit,
                        0,
                        accountingAccount?.accountingaccount? accountingAccount?.accountingaccount:-1,
                        accountingAccount?.description? accountingAccount?.description:"",
                        -1,
                        false
                    )
                } else{
                    editAccountingMovementDetailOfList(
                        selectedAccountingMovementDetail.accountingmovementdetail? selectedAccountingMovementDetail.accountingmovementdetail:-1,
                        debit!=null? 'D': 'C',
                        debit!=null? debit: credit,
                        0,
                        accountingAccount?.accountingaccount? accountingAccount?.accountingaccount:-1,
                        accountingAccount?.description? accountingAccount?.description:"",
                        selectedAccountingMovementDetail.indexList
                    )
                }
                setEditModeModal(false)
                setAddModeModal(false)
                refreshModal()
                cleanVariablesModalDetailFromModal()

            }

        }
//---------------------logica Modal fin----------------------------------------------------------------------------------------






    return (
        <div className="min-h-screen p-4 flex flex-column">
{/*-----------------------Vista inicio--------------------------------------------------------------------------------------------*/}
            <h2 className="text-2xl">Asientos Contables</h2>
            <div className='flex align-items-end justify-content-between gap-3'>
                <div className="flex flex-row gap-3 w-full">
                    <InputDate value={accountingDate} label='Fecha de asiento contable' onChange={(e: BaseSyntheticEvent) => {
                        setAccountingDate(e.target.value)
                    }}
                        className='w-full'
                    />
                    <Combobox
                        //getItems={getAccountingMovementTypes}
                        getItems={(getItemsProps:GetItemsProps)=> {
                            return getAccountingMovementTypes(getItemsProps).then((res:any)=>{
                                return [defaultAllAccountingMovementType,...res]
                            })
                        }}
                        params={{
                            language: 1,
                        }}
                        label="Tipo de asiento"
                        optionLabel="descriptionaccountingmovement"
                        value={accountingMovementType}
                        //setValue={setAccountingMovementType}
                        setValue={(e:AccountingMovementType) => {
                            if(e){
                                if (e.accountingmovementtype !== undefined && e.descriptionaccountingmovement !== undefined) {
                                    setAccountingMovementType({accountingmovementtype:e.accountingmovementtype,descriptionaccountingmovement:e.descriptionaccountingmovement});
                                }
                                setAccountingMovementType(e);
                            }
                        }}
                    />
                    <label className="w-5 pd-0 h-0" style={{display: 'flex', alignItems: 'center', marginTop:'60px'}}>
                        <span style={{fontSize: '15px'}}>Solo Manual:</span>
                        <Checkbox
                            checked={manual}
                            onChange={handleCheckboxChange}
                            color="primary"
                            className="pd-0"
                        />
                    </label>
                </div>
                <div className="flex flex-end">
                    <Button
                        className="buttonMain"
                        icon='pi pi-plus'
                        onClick={() => handleAddMode()}
                    />
                    <Button
                        className="buttonMain"
                        icon={!!selectedAccountingMovement && selectedAccountingMovement.manual?'pi pi-pencil':'pi pi-eye'}
                        visible={!!selectedAccountingMovement}
                        onClick={() => handleEditMode()}
                    />
                    <Button
                        className="buttonMain"
                        icon='pi pi-trash'
                        visible={!!selectedAccountingMovement && selectedAccountingMovement.manual}
                        onClick={() => setElimMode(true)}
                    />

                </div>
            </div>

            <CustomTable
                idTable={useId()}
                ref={tableRef}
                showGridlines
                getItems={getAccountingMovements}
                params={{ accountingDate: accountingDate? accountingDate : (lastAccountingDateOfAccountingEntry?lastAccountingDateOfAccountingEntry.accountingdate:null),
                    accountingMovementType: accountingMovementType?.accountingmovementtype? accountingMovementType?.accountingmovementtype : -1,
                    manual: manual}}
                className='crudTable'
                selectedItems={selectedAccountingMovement}
                onSelectionChange={(ae) => {
                    setSelectedAccountingMovement(ae.value)
                }}
                selectionMode="single"
                hideFiltersButton
            >
                <Column field="accountingdate" header="Fecha contable" className="column" body={(record) => {
                        const formattedDate = new Date(record.accountingdate).toLocaleDateString('es-ES');
                        return <span>{formattedDate}</span>;
                    }}/>
                <Column field="descriptionaccountingmovement" header="Descripcion" className="column"/>
                <Column field="descriptionaccountingmovementtype" header="Tipo de asiento" className="column"/>
                <Column field="totaldebitcredit" header="Total" className="column"/>
                <Column field="userfullname" header="Usuario" className="column"/>
                <Column field="recorddate" header="Registrado" className="column" body={(record) => {
                        const formattedDate = new Date(record.recorddate).toLocaleDateString('es-ES');
                        return <span>{formattedDate}</span>;
                    }}/>
                <Column field="manual" header="Manual" className="column" body={(record) => {
                        return <span>{record.manual ? 'Si' : ''}</span>;
                    }}/>
            </CustomTable>

            <Modal
                visible={elimMode}
                setVisible={setElimMode}
                header='⚠️ Atención'
                footerButtonRightText='Eliminar'
                onClickRightBtn={handleElimMode}
            >
                {<p>¿Desea eliminar este asiento contable?</p>}

            </Modal>
{/*-----------------------Vista fin-----------------------------------------------------------------------------------------------*/}






{/*-----------------------Modal inicio--------------------------------------------------------------------------------------------*/}
            <Modal
                visible={visible}
                setVisible={setVisible}
                header="Asientos Contables Manuales"
            >
                <div className="p-4 flex flex-column pd-0">
                    <div className='flex align-items-end justify-content-between gap-3'>
                        <div className="flex flex-row gap-3 w-full">
                            {isClosureEntryModal && <InputDate disable={readOnly == 0} value={closureFromDateModal} label='Desde' onChange={(e: BaseSyntheticEvent) => {
                                setClosureFromDateModal(e.target.value)
                            }}
                                className='w-full'
                                maxDate={today}
                            />}
                            <InputDate disable={readOnly == 0} value={closeDate} label={isClosureEntryModal? 'Hasta':'Fecha de asiento contable'} onChange={(e: BaseSyntheticEvent) => {
                                setCloseDate(e.target.value)
                            }}
                                className='w-full'
                            />
                            <Combobox
                                getItems={getAccountingMovementTypes}
                                params={{
                                    language: 1,
                                }}
                                label="Tipo de asiento"
                                optionLabel="descriptionaccountingmovement"
                                value={accountingMovementTypeModal}
                                setValue={setAccountingMovementTypeModal}
                                disable={readOnly == 0}
                            />
                            <InputTextCustom
                                label="Descripcion"
                                inputType={EInputTypes.TEXT}
                                value={description}
                                onChange={(e) => {
                                    setDescription(e.target.value)
                                }}
                                disable={readOnly == 0}
                            />
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h2 className="text-2xl">Detalles</h2>

                        <div className="flex flex-end">
                            {isClosureEntryModal && <Button
                                className="buttonMain"
                                visible={readOnly != 0 && !editMode}
                                disabled={!closureFromDateModal || !closeDate || disableButtonClosureEntryModal || !description || !accountingMovementTypeModal}
                                onClick={() => handleClosureEntryModal()}
                            >
                                Generar asiento de cierre
                            </Button>}
                            <Button
                                className="buttonMain"
                                icon='pi pi-plus'
                                visible={readOnly != 0}
                                disabled={!closeDate || !description || !accountingMovementTypeModal}
                                onClick={() => handleAddModeModal()}
                            />
                            <Button
                                className="buttonMain"
                                icon='pi pi-pencil'
                                visible={readOnly != 0 && !!selectedAccountingMovementDetail && selectedAccountingMovementDetail.debitcredit != 'DC'}
                                onClick={() => handleEditModeModal()}
                                disabled={!closeDate || !description || !accountingMovementTypeModal}
                            />
                            <Button
                                className="buttonMain"
                                icon='pi pi-trash'
                                visible={readOnly != 0 && !!selectedAccountingMovementDetail && selectedAccountingMovementDetail.debitcredit != 'DC'}
                                onClick={() => setElimModeModal(true)}
                                disabled={!closeDate || !description || !accountingMovementTypeModal}
                            />

                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                        <div style={{ flex: '1 1 auto', overflowY: 'auto', height: '210px' }}>
                            <CustomTable
                                idTable={useId()}
                                ref={tableRefModal}
                                showGridlines
                                getItems={crearPromesaConLista}
                                className='crudTable h-48'
                                selectedItems={selectedAccountingMovementDetail}
                                onSelectionChange={(ae) => {
                                    setSelectedAccountingMovementDetail(ae.value)
                                }}
                                selectionMode="single"
                                hideFiltersButton
                            >
                                <Column field="descriptionaccountingaccount" style={{ padding:'0px' }} header="Cuenta" className="column" body={(record: AccountingMovementDetail) => {
                                        return <span style={{ padding:record.debitcredit === 'DC' ?'50%':'', background: record.debitcredit === 'DC' ? (sumDebitValues == sumCreditValues? '#98FFD9':'#FFC6D8') : 'inherit' }}>{record.descriptionaccountingaccount}</span>
                                    }}/>
                                <Column field="debitcredit" style={{ padding:'0px' }} header="Debe" className="column" body={(record: AccountingMovementDetail) => {
                                        const digits = record.valueamd.toString().length;
                                        const decreasePercentage = digits > 0 ? digits * 1 + '%' : '0%';
                                        return <span style={{ paddingTop:'13px', paddingBottom:'13px', paddingLeft:`calc(50% - ${decreasePercentage})`, paddingRight:'60%', background: record.debitcredit === 'DC' ? (sumDebitValues == sumCreditValues? '#98FFD9':'#FFC6D8') : 'inherit' }}>{record.debitcredit != 'C'? Number(record.valueamd.toFixed(2).toLocaleString()):''}</span>
                                    }}/>
                                <Column field="debitcredit" style={{ padding:'0px' }} header="Haber" className="column" body={(record: AccountingMovementDetail) => {
                                        const digits = record.valueamd.toString().length;
                                        const decreasePercentage = digits > 0 ? digits * 1 + '%' : '0%';
                                        return <span style={{ paddingTop:'13px', paddingBottom:'13px', paddingLeft:`calc(50% - ${decreasePercentage})`, paddingRight:'60%', background: record.debitcredit === 'DC' ? (sumDebitValues == sumCreditValues? '#98FFD9':'#FFC6D8') : 'inherit' }}>{record.debitcredit == 'DC'? Number(record.valueamd2.toFixed(2).toLocaleString()):(record.debitcredit == 'C'? Number(record.valueamd.toFixed(2).toLocaleString()):'')}</span>  //si es DC, es el total de credit, en debit no hace falta aclararlo, porque su valor esta en valueamd de por si
                                    }}/>
                            </CustomTable>
                        </div>
                        
                        <div className="flex flex-end">
                            <Button label='Guardar' className='buttonMain'
                                onClick={() => setInfoModal(true)}
                                visible={readOnly != 0}
                                disabled={!closeDate || !description || !accountingMovementTypeModal || accountingMovementDetailList.length == 0}
                            />
                        </div>
                    </div>
                    
                    <Modal
                        visible={infoModal}
                        setVisible={setInfoModal}
                        header='⚠️ Atención'
                        footerButtonRightText='Si'
                        onClickRightBtn={handleClickModal}
                    >
                    
                        <p>¿Desea guardar el asiento con fecha contable el {format(closeDate?closeDate:new Date, 'PPP', { locale: es })}?</p>
                        
                        <Toast ref={toastSave} position='bottom-right' />
                    </Modal>

                    <Modal
                        visible={elimModeModal && selectedAccountingMovementDetail? true:false}
                        setVisible={setElimModeModal}
                        header='⚠️ Atención'
                        footerButtonRightText='Si'
                        onClickRightBtn={deleteAccountingMovementDetail}
                    >
                        {elimModeModal && <p>¿Desea eliminar este detalle del asiento contable?</p>}

                    </Modal>

                    <Modal
                        visible={addModeModal}
                        setVisible={setAddModeModal}
                        header={!editModeModal? "Agregar Detalle": "Editar Detalle"}
                        footerButtonRightText="Agregar"
                        onClickRightBtn={addAccountingMovementDetail}
                    >
                        
                        <div className="flex flex-row gap-4">
                            <Combobox
                                getItems={getAllAccountings}
                                label="Plan de cuentas"
                                optionLabel="description"
                                value={accounting}
                                setValue={setAccounting}
                            />
                            <Combobox
                                getItems={getAllAccountingAccountsByLevel}
                                params={{
                                    accounting: accounting?.accounting,
                                    level: accounting?.treesize,
                                }}
                                label="Cuenta contable"
                                caption={accountingAccountError? "Este campo debe estar completo" : ""}
                                error={accountingAccountError}
                                placeholder="Ejemplo: xxxxx (X.X.X)"
                                optionLabel="fulldescription"
                                value={accountingAccount}
                                setValue={(value) => {
                                    setAccountingAccount(value)
                                    setAccountingAccountError(false)
                                }}
                                disable = {!accounting}
                            />
                        </div>

                        <div className="flex flex-row gap-4">
                            <InputTextCustom
                                label="Debe"
                                error={debitError}
                                caption={debitError ? "Completa al menos uno de los dos campos" : ""}
                                minFractionDigits={1}
                                inputType={EInputTypes.NUMBER}
                                value={debit}
                                onChange={(e) => {
                                    setDebit(e.target.value)
                                    setDebitError(false)
                                    setCreditError(false)
                                }}
                                disable={credit}
                            />
                            <InputTextCustom
                                label="Haber"
                                error={creditError}
                                caption={creditError ? "Completa al menos uno de los dos campos" : ""}
                                minFractionDigits={1}
                                inputType={EInputTypes.NUMBER}
                                value={credit}
                                onChange={(e) => {
                                    setCredit(e.target.value)
                                    setCreditError(false)
                                    setDebitError(false)
                                }}
                                disable={debit}
                            />
                        </div>

                    </Modal>

                    <Modal
                        visible={isOpeningEntryModal && !editMode}
                        setVisible={setIsOpeningEntryModal}
                        header='⚠️ Atención'
                        footerButtonRightText='Si'
                        onClickRightBtn={handleOpeningEntryModal}
                    >
                        <p>¿Desea generar un asiento de apertura?</p>{/*Si cierra la ventana, y el accountingMovementTypeModal era de apertura, debe vaciar el cbo*/}

                    </Modal>

                    <Toast ref={toastModal} position='bottom-right' />    {/*Toast Modal, para lo que debe aparecer en la Modal*/}
                
                </div>
            </Modal>
{/*-----------------------Modal fin-----------------------------------------------------------------------------------------------*/}




            <Toast ref={toast} position='bottom-right' />    {/*Toast Vista, para lo que debe aparecer en la vista, como guardar los datos de la Modal*/}
        
        </div>
    )

}

export default AccountingMovementsView
